import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Icons } from './Icons';
import SupportChatPanel from './SupportChatPanel';

const SupportChat = () => {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <SupportChatPanel isOpen={open} onClose={() => setOpen(false)} />

      <motion.button
        whileTap={{ scale: 0.93 }}
        onClick={() => setOpen(o => !o)}
        onHoverStart={() => setHovered(true)}
        onHoverEnd={() => setHovered(false)}
        title="Support Chat"
        aria-label="Open Support Chat"
        style={{
          position: 'fixed',
          bottom: 'calc(env(safe-area-inset-bottom, 0px) + 24px)',
          right: 16,
          zIndex: 50,
          width: 46,
          height: 46,
          borderRadius: '50%',
          border: `1px solid ${open || hovered ? 'rgba(90,56,253,0.55)' : 'rgba(90,56,253,0.3)'}`,
          background: open
            ? 'linear-gradient(135deg, #7F00FF, #5A38FD)'
            : 'linear-gradient(135deg, #5A38FD 0%, #7F00FF 100%)',
          boxShadow: open || hovered
            ? '0 6px 32px rgba(90,56,253,0.5), 0 0 0 4px rgba(90,56,253,0.12)'
            : '0 4px 20px rgba(90,56,253,0.3)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: hovered && !open ? 'translateY(-2px)' : 'translateY(0)',
          transition: 'box-shadow 200ms ease, transform 200ms ease, border-color 200ms ease',
        }}
      >
        <AnimatedIcon open={open} />
      </motion.button>
    </>
  );
};

function AnimatedIcon({ open }) {
  return (
    <motion.div
      animate={{ rotate: open ? 90 : 0, scale: open ? 0.9 : 1 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      style={{ display: 'flex' }}
    >
      {open ? (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      ) : (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      )}
    </motion.div>
  );
}

export default SupportChat;
